/*
 * Copyright Mimic Networks, Inc. 2024.
 */

import { UsersPage } from '@/pages/Users/UsersPage';

export function UsersRoute() {
  return <UsersPage />;
}
